import React, { Component } from 'react';

import classes from './SplashScreen.css';

import motorDataIcon from '../../assets/images/icon-wire.svg';
import footerLogo from '../../assets/images/se-logo-white.svg';

class SplashScreen extends Component {
  state = {
    display: ''
  };

  componentWillMount = () => {
    setTimeout(this.show, this.props.wait);
  };

  show = () => {
    this.setState({ display: 'none' });
  };

  render() {
    return (
      <div style={{ display: this.state.display }}>
        <div className={classes.SplashScreen}>
          <div className={classes.ContentWrapper}>
            <div className={classes.LogoWrapper}>
              <img src={motorDataIcon} alt="Icon" />
              <h1>Wire Data Calculator</h1>
            </div>
          </div>
          <footer>
            <img src={footerLogo} alt="Schneider Logo" />
          </footer>
        </div>
      </div>
    );
  }
}

export default SplashScreen;
